<template>
  <div>
    <div />
  </div>
</template>

<script>
export default {
  name: 'VbVendorCredits',
  components: {},
}
</script>
